import makeCustomResolutionResultFromTypedValue from 'notebook/integrations/samples/transfer-table-columns/makeCustomResolutionResultFromTypedValue';
import {
  ServerResolutionResult,
  TestDefinitionTableColumnValueQuery,
} from 'notebook/tables/string-resolution/StringResolutionConstants';
import {TestDefinitionsTableColumn} from 'procedures/tables/ProcedureTableConstants';
import {fetchTestDefinitionSearchSummary} from 'sample-tests/search/testDefinitionSearchUtils';
export async function resolveTestDefinitionTableColumnValueFromSearchSummary(
  query: TestDefinitionTableColumnValueQuery
): Promise<ServerResolutionResult> {
  const {testDefinitionId, column} = query;
  const testDefinition = await fetchTestDefinitionSearchSummary(testDefinitionId);

  if (!testDefinition) {
    return makeCustomResolutionResultFromTypedValue(null, 'Test definition not accessible');
  }
  return makeCustomResolutionResultFromTypedValue({
    type: 'STRING',
    rawValue:
      column === TestDefinitionsTableColumn.DESCRIPTION
        ? testDefinition.description
        : testDefinition.resultSchemaName,
  });
}
